import React, { useState } from 'react';
import axios from 'axios';
import { useToast } from '../hooks/use-toast';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Newsletter = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const { toast } = useToast();

  const submit = async (e) => {
    e.preventDefault();
    if (!email || !email.includes('@')) {
      toast({ title: 'Enter a valid email', description: 'Please provide a valid email address to subscribe.' });
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/newsletter`, { email });
      toast({ title: 'Subscribed!', description: `Thanks - ${email} is now on the DCTV list.` });
      setEmail('');
    } catch (err) {
      const detail = err?.response?.data?.detail || 'Something went wrong. Please try again.';
      toast({ title: 'Could not subscribe', description: detail });
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="py-20 px-6 lg:px-10">
      <div className="max-w-[1200px] mx-auto">
        <div className="relative overflow-hidden rounded-3xl border border-white/8 px-6 py-16 md:py-20"
          style={{ background: 'radial-gradient(120% 140% at 15% 0%, rgba(232,116,59,0.16) 0%, rgba(10,14,22,0) 55%), #0c1119' }}>
          <div className="relative z-10 max-w-2xl mx-auto text-center">
            <h2 className="font-serif-dctv text-3xl md:text-4xl font-bold text-white">The best of the community, in your inbox</h2>
            <p className="text-[#9aa3b2] mt-4 text-[15px] leading-relaxed">
              Subscribe to receive news and updates from DCTV, and be the first to get our exclusives, programmes and events.
            </p>
            <form onSubmit={submit} className="mt-8 flex flex-col sm:flex-row items-center gap-3 max-w-md mx-auto">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
                className="w-full flex-1 px-5 py-3 rounded-full bg-[#0a0e16] border border-white/10 text-white placeholder:text-[#6b7384] focus:outline-none focus:border-[#e8743b]/60 transition-colors"
              />
              <button type="submit" disabled={loading} className="dctv-btn-primary px-7 py-3 rounded-full text-sm font-semibold whitespace-nowrap disabled:opacity-60">
                {loading ? 'Subscribing…' : 'Subscribe'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Newsletter;
